/**
 * Check if the user is on a mobile device
 * @param _navigator - The navigator object to check
 * @returns True if the user is on a mobile device, false otherwise
 */
export default function isMobile(_navigator: Navigator = navigator): boolean {
    // 1. Use the modern API if available (Chrome/Edge/Blink)
    if (isNavigatorWithUserAgentData(_navigator)) {
        return _navigator.userAgentData.mobile
    }

    // 2. Fallback for Safari and Firefox with a simple Regex
    return /Mobi|Android|iPhone|iPad|iPod/i.test(_navigator.userAgent)
}

interface NavigatorWithUserAgentData extends Navigator {
    userAgentData?: {
        mobile: boolean
    }
}

function isNavigatorWithUserAgentData(
    _navigator: Navigator,
): _navigator is NavigatorWithUserAgentData {
    return 'userAgentData' in _navigator
}
